<template>
  <chicklet
    :color="status.color"
    :max-width="maxWidth"
    :class="{ 'status-selection-button__selected' : selected }"
    :type="chickletType"
    is-uppercase
    size="medium"
    class="status-selection-button"
  >
    <span>{{ status.name }}</span>
    <avatar v-if="hasJobs" :person="getAssignee()" :size="19" />
  </chicklet>
</template> 
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IJobInfo } from '@/types/data-objects/items'
import {
  IPersonWithEmail,
  IStatusForSelection,
} from '@/api/types/response.types'

export default defineComponent({
  name: 'StatusSelectionButton',

  props: {
    status: {
      type: Object as () => IStatusForSelection,
      required: true,
    },
    size: {
      type: String,
      default: 'tiny',
    },
    maxWidth: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },
  },

  computed: {
    chickletType(): string {
      return this.selected ? 'flat' : 'transparent'
    },
    hasJobs(): boolean {
      return this.jobInfo !== null
    },
  },

  methods: {
    // There could be a case where the current assignee IS NOT the mandated assignee
    // (e.g. job rule updated, jobs were turned off before and it was a different assignee).
    // So, only use the assignee mandate if this represents a status that isn't the current one.
    getAssignee(): IPersonWithEmail {
      if (this.status.id === this.jobInfo.currentStatus.id) {
        return this.jobInfo.currentAssignee
      }
      const mandate = this.jobInfo.assigneeMandates.find(
        am => am.statusID === this.status.id,
      )
      return mandate
        ? this.jobInfo.jobAppointees.find(ja => ja.job.id === mandate.jobID)
            .appointee
        : null
    },
  },
})
</script>

<style lang="scss">
.status-selection-button {
  cursor: pointer;
  opacity: 0.7;

  &__selected {
    opacity: 1;
  }

  .avatar {
    margin-left: 6px;
  }
}
</style>
